import { GenericDataType } from "./GenericDataType";

export class GenericFieldDefinition {
    name: string;
    type: GenericDataType = GenericDataType.string;
}
